import {css, html} from 'lit';
import {customElement, property, state} from 'lit/decorators';
import {containerStyles, moduleSpacingStyles, normalizeStyles} from "@webs/components-library/theming";
import {GridColumn} from "@webs/components-library/grid-column";

@customElement('webs-card-team')
export class CardTeam extends GridColumn {


  static styles = [...GridColumn.styles,
    normalizeStyles,
    moduleSpacingStyles,
    containerStyles,
    css`
        .m-card-team {
          display: block;
          height: 100%;
          perspective: 300rem;
          -moz-perspective: 300rem;
          position: relative;
       }

        .m-card-team__side {
         display: flex;
         flex-direction: column;
          transition: all 1s ease;
          width: 100%;
          backface-visibility: hidden;
          text-align: center;
          color: var(--color-white);
          padding: 2rem 1.4rem;
       }

       .m-card-team__side-back {
          overflow: hidden;
          padding: 2rem 1.2rem 1.6rem 1.2rem;
       }

       .m-card-team__side-name {
          margin: 0;
          margin-top: 0.8rem;
          font-size: 0.7rem;
          line-height: 1.3;
          color: var(--color-dark-grey);
          font-weight: var(--font-weight-strong);
          text-align: center;
          text-transform: uppercase;
          font-family: var(--font-family-alternative);

       }

       .m-card-team__side-title {
          font-size: 1rem;
          line-height: 1.3;
          color: var(--color-dark-grey);
          margin-bottom: 0;
       }


       .m-card-team__side-front {
          background: var(--color-light-grey);
          border-radius: 16px;
       }

       .m-card-team__side-back {
          background: linear-gradient(
          216.4deg,
          var(--color-orange) 22.12%,
          var(--color-pink) 110.96%
        );
          color: white;
          border-radius: 16px;
          transform: rotateY(180deg);
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
       }

       .m-card-team__side-icon {
          border-radius: 50%;
          width: 120px;
          height: 120px;
          margin-top: 1.6rem;
          margin-bottom: 0rem;
          object-fit: cover;
       }

       .m-card-team__name-back {
          font-size: 0.6rem;
          font-weight: var(--font-weight-strong);
          text-transform: uppercase;
          line-height: 1.3;
          margin-top: 0.4rem;
          margin-bottom: 0;
          font-family: var(--font-family-alternative);
       }

       .m-card-team__social-links {
          margin-top: auto;
       }

        .m-card-team__side-description-back {
          font-family: var(--font-family-alternative);
          font-size: 0.8rem;
          line-height:1.3;
          margin-top: 1.2rem;
          margin-bottom: 0;
          max-height: 170px;
          overflow: auto;
          height: 100%;
        }

        .m-card-team__side-back--button {
          font-size: 0.8rem;
          font-weight: var(--font-weight-strong);
          font-family: var(--font-family-alternative);
          line-height: 1.2;
          color: #fff;
          margin-top: 1.8rem;
          cursor: pointer;
        }

        .m-card-team__side-front--button {
          font-size: 0.8rem;
          font-weight: var(--font-weight-strong);
          font-family: var(--font-family-alternative);
          line-height: 1.2;
          color: var(--color-dark-grey);
          margin-top: 1.8rem;
          margin-bottom: 0;
          cursor: pointer;
        }

       .flipped.m-card-team__side-front  {
           transform: rotateY(-180deg);
         }

       .flipped.m-card-team__side-back  {
          transform: rotateY(0);
        }



      @media only screen and (min-width: 992px){

      .m-card-team__side-icon {

       }

        .m-card-team__side-title {
          font-size: 1.2rem;
       }

         .m-card-team__name-back {
              font-size: 0.7rem;
           }
         .m-card-team__side-front {
            display: flex;
            flex-direction: column;
            height: 100%;
            justify-content: space-between;
         }
          .m-card-team__social-links {
              margin-top: 2.5rem;
           }

           .m-card-team__side-description-back {
              max-height: 180px;
           }

            .m-card-team__side-name {
              font-size: 0.8rem;
            }

         .m-card-team:hover .m-card-team__side-front  {
          cursor: pointer;
          transform: rotateY(-180deg);
        }

        .m-card-team:hover .m-card-team__side-back  {
          transform: rotateY(0);
        }

         .m-card-team__side-front--button {
          display: none;
        }

        .m-card-team__side-back--button  {
           display: none;
        }


      }
    `];

  private smallDevice: MediaQueryList = window.matchMedia('(min-width: 992px)');
  @state()
  private isDesktop: boolean;

  @property()
  function: string;


  @property()
  icon: string

  @property()
  name: string


  @property({attribute: 'name-back'})
  nameBack: string;

  @property({attribute: 'description-back'})
  descriptionBack: string;

  @property({attribute: 'text-front'})
  textFront: string;

  @property({attribute: 'text-back'})
  textBack: string;


  connectedCallback() {
    super.connectedCallback();
    this.smallDevice.addEventListener('change', (e) => this.handleDeviceChange(e));
  }




  protected render(): unknown {
    return html`
          <div class="m-card-team">
            <div class="m-card-team__side m-card-team__side-front">
              ${this.function ? html`<p class="m-card-team__side-title">${this.function}</p>` : ''}
              <div class="meta-info">
                ${this.icon ? html`<img class="m-card-team__side-icon" src="${this.icon}" alt="Icon" loading="lazy" width="120">`: ''}
                ${this.name ? html`<p class="m-card-team__side-name">${this.name}</p>` : ''}
              </div>
              <a class="m-card-team__side-front--button" @click="${this.flipCard}">
                ${this.textFront ? this.textFront : ''}
              </a>
            </div>
            <div class="m-card-team__side m-card-team__side-back">
              ${this.nameBack ? html`<p class="m-card-team__name-back">${this.nameBack}</p>` : ''}
              ${this.descriptionBack ? html`<p class="m-card-team__side-description-back">${this.descriptionBack}</p>` : ''}
              <div class="m-card-team__social-links">
                <slot  name="social-links"></slot>
              </div>
              <a class="m-card-team__side-back--button" @click="${this.flipCardBack}">
                ${this.textBack ? this.textBack : ''}
              </a>
            </div>
          </div>
      `
  }

  private flipCard() {
    const front = this.shadowRoot.querySelector('.m-card-team__side-front');
    const back = this.shadowRoot.querySelector('.m-card-team__side-back');
    front.className += ' flipped'
    back.className += ' flipped'
  }

  private flipCardBack() {
    const front = this.shadowRoot.querySelector('.m-card-team__side-front');
    const back = this.shadowRoot.querySelector('.m-card-team__side-back');
    front.classList.remove('flipped');
    back.classList.remove('flipped');
  }

  private handleDeviceChange(event): void {
    this.isDesktop = event.matches;
    this.requestUpdate();
  }

}
